(() => {
    const modalState = {
        isContactPopupVisible: false,
        isPauseOverlayVisible: false,
        setContactPopupVisible(value) {
            this.isContactPopupVisible = value;
        },
    };

    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modalOverlay");
    const modalClose = document.getElementById("modalClose");
    const meetingContainer = document.getElementById("meetingContainer");

    let scriptEl = null;

    function toggleModal() {
        const appElement = document.getElementById("app");
        if (appElement) {
            if (appElement.style.zIndex === "999") {
                appElement.style.zIndex = modalState.isPauseOverlayVisible
                    ? "1"
                    : "9999999";
            } else {
                if (scriptEl) {
                    document.body.removeChild(scriptEl);
                    scriptEl = null;
                    modalState.setContactPopupVisible(false);
                } else {
                    appElement.style.zIndex = "999";
                }
            }
        }
    }

    function showModal() {
        modal.style.display = "flex";
        toggleModal();
    }

    function hideModal() {
        modal.style.display = "none";
        toggleModal();
    }

    modalOverlay.addEventListener("click", hideModal);
    modalClose.addEventListener("click", hideModal);

    document.addEventListener("DOMContentLoaded", () => {
        if (modalState.isContactPopupVisible) {
            showModal();
        }

        const togglePopupElements = document.querySelectorAll(
            ".toggle-popup-contact-mksun",
        );
        for (const element of togglePopupElements) {
            element.addEventListener("click", showModal);
        }
    });

    window.addEventListener("beforeunload", hideModal);
})();
